/* unplugin-vue-components disabled */import { render } from "./SdkInfo.vue?vue&type=template&id=2093a832&scoped=true"
import script from "./SdkInfo.vue?vue&type=script&lang=js"
export * from "./SdkInfo.vue?vue&type=script&lang=js"

import "./SdkInfo.vue?vue&type=style&index=0&id=2093a832&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2093a832"]])

export default __exports__